import { CloseIcon } from "@chakra-ui/icons";
import { Box, HStack, IconButton, Text } from "@chakra-ui/react";
import { useFormatMoney } from "hooks/use-format-money";
import type {
  NumberFilter,
  ShowOnlyOptions,
} from "modules/vendor-portal/screens/feedback/utils";
import { upperFirst } from "utils/string";

const getNumberFilterText = (
  formatMoney: ReturnType<typeof useFormatMoney>,
  numberFilter: NumberFilter,
) => {
  switch (true) {
    case "lte" in numberFilter:
      return `Less than ${formatMoney(numberFilter.lte)}`;
    case "gte" in numberFilter:
      return `More than ${formatMoney(numberFilter.gte)}`;
    case "between" in numberFilter:
    default:
      return `Between ${formatMoney(numberFilter.between[0])} - ${formatMoney(
        numberFilter.between[1],
      )}`;
  }
};

const getShowOnlyBadgeText = (
  formatMoney: ReturnType<typeof useFormatMoney>,
  showOnly: ShowOnlyOptions,
) => {
  switch (showOnly.key) {
    case "repeat_attendee":
      return "Repeat attendees";
    case "interest_level":
      return `Interest level: ${
        showOnly.value === "unknown" ? "Neutral" : upperFirst(showOnly.value)
      }`;
    case "enquiry_source":
      return `Enquiry source: ${upperFirst(showOnly.value)}`;
    case "price_indication":
      return `Price indication: ${getNumberFilterText(
        formatMoney,
        showOnly.value,
      )}`;
    default:
      return null;
  }
};

export function ShowOnlyBadge({
  showOnly,
  clear,
}: {
  showOnly?: ShowOnlyOptions;
  clear?: () => void;
}) {
  const formatMoney = useFormatMoney();
  if (!showOnly) return null;

  return (
    <Box p={2} px={4} bgColor={"indigo.100"} borderRadius={"md"}>
      <HStack spacing={2}>
        <Text> {getShowOnlyBadgeText(formatMoney, showOnly)}</Text>
        <IconButton
          colorScheme={"indigo"}
          variant={"ghost"}
          aria-label={"Clear show only filter"}
          size={"xs"}
          icon={<CloseIcon />}
          onClick={clear}
          borderRadius={"full"}
        />
      </HStack>
    </Box>
  );
}
